document.addEventListener('DOMContentLoaded', () => {
  const looksWrapper = document.querySelector('.lookbooks__looks');
  const looks = Array.from(looksWrapper.querySelectorAll('.lookbooks__look'));
  const showMoreButton = document.querySelector('.lookbooks__paginate-btn');

  let currentShowCount;

  const showLooks = () => {
    const isMobile = window.matchMedia('(max-width: 576px)').matches;
    const isTablet = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      currentShowCount = 2;
    } else if (isTablet) {
      currentShowCount = 8;
    } else {
      currentShowCount = parseInt(looksWrapper.dataset.show, 10);
    }

    looks.forEach(look => look.style.display = 'none');
    looks.slice(0, currentShowCount).forEach(look => look.style.display = 'block');
    checkButtonVisibility();
  };

  const checkButtonVisibility = () => {
    showMoreButton.style.display = currentShowCount >= looks.length ? 'none' : 'block';
  };

  const updateLooksOnResize = () => {
    showLooks();
    checkButtonVisibility();
  };

  const onShowMoreClick = () => {
    const increment = window.matchMedia('(max-width: 576px)').matches ? 2 : window.matchMedia('(max-width: 768px)').matches ? 2 : 3;
    currentShowCount += increment;
    looks.slice(0, currentShowCount).forEach(look => look.style.display = 'block');
    checkButtonVisibility();
  };

  window.addEventListener('resize', debounce(updateLooksOnResize, 250));
  showMoreButton.addEventListener('click', onShowMoreClick);

  showLooks();
});

// Helper function for debounce
function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this, args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
